import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-admin-institution-type-edit',
  templateUrl: './admin-institution-type-edit.component.html'
})
export class AdminInstitutionTypeEditComponent implements OnChanges, OnInit {
  @Input() formdata;
  @Input() types;
  @Input() groups;
  @Output() doSave = new EventEmitter();
  @Output() doCancel = new EventEmitter();
  form;
  
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      id: ['', ''],
      prefix: ['', ''],
      name: ['', ''],
      branchId: ['', ''],
      description: ['', ''],
      institutionGroupId: ['', '']
    });
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.formdata.currentValue) {
      this.form?.patchValue(changes?.formdata.currentValue);
    }
  }

  saveInstitutionType() {
    this.doSave.emit(this.form.value);
  }

  cancel() {
    this.doCancel.emit();
  }

  setGroup(evt) {
    this.form.patchValue({ institutionGroupId: evt.value });
  }
}
